angular.module('gym.calendar').controller('BookingInfoCtrl', ["$scope", "$rootScope", "$modalInstance", "EventService", "Events", "booking", function($scope, $rootScope, $modalInstance, EventService, Events, booking) {
  var getRecurringBookings;
  $scope.booking = booking;
  Events.one(`${booking.event_id}`).get().then(function(event) {
    $scope.event = event;
    return getRecurringBookings();
  });
  Events.one(`${booking.event_id}`).one('bookings', booking.id).get().then(function(b) {
    return $scope.booking = b;
  });
  $scope.gym = $rootScope.gym;
  $scope.usesEventTypeAttendeeLimits = $scope.gym.gym_config.uses_event_type_attendee_limits;
  $scope.currency = $rootScope.gym.currency_symbol;
  getRecurringBookings = function() {
    var params;
    params = {
      event_schedule_id: $scope.event.event_schedule_id,
      contact_id: booking.student_id
    };
    return EventService.getRecurringBookings(params).then(function(recurringBookings) {
      return $scope.recurringBookings = recurringBookings;
    });
  };
  $scope.recurringBookingsEnabled = function() {
    if (!$scope.recurringBookings) {
      return;
    }
    if ($scope.recurringBookings.length) {
      return 'Yes';
    } else {
      return 'No';
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
